import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { DikshaEntryRequest } from '../../services/raintree/interfaces/dp-entry';
import {
  MatAutocomplete,
  MatAutocompleteModule,
} from '@angular/material/autocomplete';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { LoaderComponent } from '../../common-component/loader/loader.component';
import { SurnameTransmissionService } from '../../services/raintree/Transmission/surname.transmission';
import { ToastrService } from 'ngx-toastr';
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { PincodeTransmissionService } from '../../services/raintree/Transmission/pincode.service';
import { PincodeInterface } from '../../services/raintree/interfaces/pincode.interface';
import { CaptureImgPopupComponent } from '../capture-img-popup/capture-img-popup.component';
import { RitwikTransmissionService } from '../../services/raintree/Transmission/ritwik.transmission.service';
import { OblateDetailsService } from '../../services/raintree/Transmission/oblate.service';

import { DpnfSuccessComponent } from '../../views/common/dpnf-success/dpnf-success.component';
import { DpSuccessMessageComponent } from '../../common-component/dp-success-message/dp-success-message.component';
import { SnackbarService } from '../../services/common/snackbar.service';

@Component({
  selector: 'app-add-new-oblate-popup',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    LoaderComponent,
    CommonModule,
    MatDialogModule,
  ],
  templateUrl: './add-new-oblate-popup.component.html',
  styleUrl: './add-new-oblate-popup.component.scss',
})
export class AddNewOblatePopupComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    @Inject(PLATFORM_ID) private platformId: Object,
    private surnameTransmissionService: SurnameTransmissionService,
    private toaster: ToastrService,
    private pincodeTransmissionService: PincodeTransmissionService,
    private dialog: MatDialog,
    private snackbar: SnackbarService,
    private ritwikTransmissionService: RitwikTransmissionService,
    private oblateService: OblateDetailsService,
    private dialogRef: MatDialogRef<AddNewOblatePopupComponent>
  ) {}
  @ViewChild('auto') auto!: MatAutocomplete;
  @ViewChild('auto1') auto1!: MatAutocomplete;
  @ViewChild('autogl') autogl!: MatAutocomplete;
  initiationDetails!: FormGroup;
  reqbody!: DikshaEntryRequest;
  selectedLastName: boolean = false;
  selectedGuardianLastName: boolean = false;
  surnameList: any[] = [];
  ritwikList: any[] = [];
  checkBoxClick: boolean = false;
  presDistArr: any[] = [];
  permDistArr: any[] = [];
  isLoading: boolean = false;
  isMobile: boolean = false;
  stepOne: boolean = false;
  stepOneDone: boolean = false;
  maxDate: string = '';
  hasCamera: boolean = false;
  @ViewChild('videoRef') videoRef!: ElementRef;
  @ViewChild('canvasRef') canvasRef!: ElementRef;
  capturedImage: any = '';
  loading: boolean = false;
  selectedRitwik: boolean = false;
  ritwikCode: string = '';
  allowedKeys: any[] = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete'];
  ngOnInit(): void {
    const today = new Date();
    this.maxDate = today.toISOString().split('T')[0];
    this.initiationDetails = this.formBuilder.group({
      permAddress: ['', Validators.required],
      permPincode: ['', Validators.required],
      permDistrict: ['', Validators.required],
      permState: ['', Validators.required],
      permCountry: ['', Validators.required],
      presAddress: ['', Validators.required],
      presPincode: ['', Validators.required],
      presDistrict: ['', Validators.required],
      presState: ['', Validators.required],
      presCountry: ['', Validators.required],
      age: ['', Validators.required],
      checkBox: [false],
      qualification: ['', Validators.required],
      race: ['', Validators.required],
      varna: ['', Validators.required],
      initiatedMember: ['', Validators.required],
      occupation: ['', Validators.required],
      initiationDate: ['', Validators.required],
      initiationPlace: ['', Validators.required],
      firstName: ['', Validators.required],
      middleName: [''],
      lastName: ['', Validators.required],
      guardianFname: ['', Validators.required],
      guardianMname: [''],
      guardianLname: ['', Validators.required],
      ritwikName: ['', Validators.required],
      contactNo: ['', [Validators.required]],
    });
    this.isMobile = this.isMobileBrowser();
    this.initiationDetails.get('permCountry')?.setValue('INDIA');
    this.initiationDetails.get('presCountry')?.setValue('INDIA');
    this.initiationDetails
      .get('ritwikName')
      ?.valueChanges.subscribe((value) => {
        this.selectedRitwik = false;
        this.ritwikCode = '';
        if (value.length >= 3) {
          this.ritwikTransmissionService.getRitwikListV2(value).subscribe({
            next: (response: any) => {
              if (!response.error) {
                this.ritwikList = response.data;
              }
            },
            error: (error) => {
              this.toaster.clear();
              this.toaster.error(error);
            },
          });
        } else this.ritwikList = [];
      });
    this.initiationDetails.get('lastName')?.valueChanges.subscribe((value) => {
      this.selectedLastName = false;
      this.surnameList = [];
      if (value.length >= 3) {
        this.surnameTransmissionService
          .getSurnameList({ input: value })
          .subscribe({
            next: (response: any) => {
              if (!response.error) {
                this.surnameList = response.data;
              }
            },
            error: (error) => {
              this.toaster.clear();
              this.toaster.error(error);
            },
          });
      } else this.surnameList = [];
    });
    this.initiationDetails
      .get('guardianLname')
      ?.valueChanges.subscribe((value) => {
        this.selectedGuardianLastName = false;
        this.surnameList = [];
        if (value.length >= 3) {
          this.surnameTransmissionService
            .getSurnameList({ input: value })
            .subscribe({
              next: (response: any) => {
                if (!response.error) {
                  this.surnameList = response.data;
                }
              },
              error: (error) => {
                this.toaster.clear();
                this.toaster.error(error);
              },
            });
        } else this.surnameList = [];
      });
    this.initiationDetails
      .get('presPincode')
      ?.valueChanges.subscribe((value) => {
        this.presDistArr = [];
        this.initiationDetails.get('presState')?.setValue('');
        this.initiationDetails.get('presDistrict')?.setValue('');
        if (value.length === 6) {
          this.isLoading = true;
          this.pincodeTransmissionService.getStateDistrict(value).subscribe({
            next: (response: PincodeInterface) => {
              if (!response.error) {
                let state: any[] = response.data.states;
                this.presDistArr = response.data.districts;
                if (this.presDistArr.length === 1)
                  this.initiationDetails
                    .get('presDistrict')
                    ?.setValue(this.presDistArr[0]);
                this.initiationDetails.get('presState')?.setValue(state[0]);
                this.isLoading = false;
              }
            },
            error: (error) => {
              this.isLoading = false;
              this.toaster.error(error);
              this.initiationDetails.get('dikshaPincode')?.setValue('');
            },
          });
        }
      });
    this.initiationDetails
      .get('permPincode')
      ?.valueChanges.subscribe((value) => {
        this.permDistArr = [];
        this.initiationDetails.get('permState')?.setValue('');
        this.initiationDetails.get('permDistrict')?.setValue('');
        if (value.length === 6) {
          this.isLoading = true;
          this.pincodeTransmissionService.getStateDistrict(value).subscribe({
            next: (response: PincodeInterface) => {
              if (!response.error) {
                let state: any[] = response.data.states;
                this.permDistArr = response.data.districts;
                if (this.permDistArr.length === 1)
                  this.initiationDetails
                    .get('permDistrict')
                    ?.setValue(this.permDistArr[0]);
                this.initiationDetails.get('permState')?.setValue(state[0]);
                this.isLoading = false;
              }
            },
            error: (error) => {
              this.isLoading = false;
              this.toaster.error(error);
              this.initiationDetails.get('dikshaPincode')?.setValue('');
            },
          });
        }
      });
  }
  createPayload(): any {
    const payLoad = this.initiationDetails.value;
    delete payLoad.checkBox;
    return payLoad;
  }
  onRitwikDropDown(item: any) {
    console.log(item);
    this.initiationDetails.get('ritwikName')?.setValue(item.dwd_worker_name);
    this.selectedRitwik = true;
    this.ritwikCode = item.dwd_ritwik_code;
  }
  onSelectDropDown(value: any, formControlName: string) {
    this.initiationDetails.get(formControlName)?.setValue(value);
  }
  isMobileBrowser(): boolean {
    const userAgent = isPlatformBrowser(this.platformId)
      ? window.navigator.userAgent
      : '';
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent
    );
  }
  onCheckboxChange(event: any) {
    this.checkBoxClick = !this.checkBoxClick;
    if (this.checkBoxClick) {
      this.initiationDetails.get('checkBox')?.setValue(true);
      this.initiationDetails
        .get('permAddress')
        ?.setValue(this.initiationDetails.get('presAddress')?.value);
      this.initiationDetails
        .get('permPincode')
        ?.setValue(this.initiationDetails.get('presPincode')?.value);
      this.initiationDetails
        .get('permState')
        ?.setValue(this.initiationDetails.get('presState')?.value);
      this.initiationDetails
        .get('permDistrict')
        ?.setValue(this.initiationDetails.get('presDistrict')?.value);
      this.permDistArr[0] = this.initiationDetails.get('presDistrict')?.value;
    } else {
      this.initiationDetails.get('permAddress')?.setValue('');
      this.initiationDetails.get('permPincode')?.setValue('');
      this.initiationDetails.get('permState')?.setValue('');
      this.initiationDetails.get('permDistrict')?.setValue('');
      this.permDistArr = [];
    }
  }
  onLastNameDropDown(value: string, type: string) {
    console.log(value, type);
    if (type === 'ln') this.selectedLastName = true;
    else this.selectedGuardianLastName = true;
  }

  onNextClick() {
    this.markAllAsTouched(1);
    if (
      this.selectedGuardianLastName &&
      this.selectedRitwik &&
      this.selectedLastName &&
      this.initiationDetails.valid
    ) {
      this.stepOneDone = true;
    }
  }
  firstDigit: number = 0;
  markAllAsTouched(stepNo: number) {
    this.stepOne = true;
    Object.values(this.initiationDetails.controls).forEach((control) => {
      control.markAsTouched();
    });
    const contactValue = this.initiationDetails
      .get('contactNo')
      ?.value?.toString();
    if (contactValue) {
      this.firstDigit = parseInt(contactValue.charAt(0), 10);
      if (this.firstDigit < 6) {
        this.initiationDetails.get('contactNo')?.markAsTouched;
        this.initiationDetails.get('contactNo')?.setValue('');
      }
    }
  }
  returnFilesArr: any[] = [];
  isImageFile(file: Blob): boolean {
    const imageMimeTypes = ['image/jpeg', 'image/png', 'image/jpg']; // Add more image MIME types if needed
    return imageMimeTypes.includes(file.type);
  }
  photos(event: any, type: string) {
    const target = event.target as HTMLInputElement;
    if (!target || !target.files) {
      return;
    }
    const files: FileList = target.files;
    if (this.isImageFile(files[0])) {
      if (type === 'f') {
        this.returnFilesArr[0] = files[0];
        // this.initiationDetails
        //   .get('dp_book_frontpgImg')
        //   ?.setValue(this.returnFilesArr[0]);
      } else {
        if (this.returnFilesArr.length === 0) {
          this.returnFilesArr[0] = '';
        }
        this.returnFilesArr[1] = files[0];
      }
    } else {
      console.log('tfntg');
      this.toaster.error('Add only .jpg/ .jpeg/ .png image type');
    }
  }
  onPreviousClick() {
    this.stepOneDone = false;
  }
  onImgClick() {
    this.dialog.open(CaptureImgPopupComponent);
  }
  onSubmit() {
    if (this.returnFilesArr.length < 2) {
      this.toaster.error('Enter both front and back image of diksha patra');
    } else {
      let payLoad = this.createPayload();
      payLoad = {
        ...payLoad,
        dp_book_frontpgImg: this.returnFilesArr[0],
        dp_book_backpgImg: this.returnFilesArr[1],
        ritwikCode: this.ritwikCode,
      };
      console.log(payLoad, 'pay');
      this.oblateService.addOblate(payLoad).subscribe({
        next: (response) => {
          console.log(response.error);
          if (!response.error) {
            this.dialog.open(DpSuccessMessageComponent, {
              panelClass: 'common-pannel-dialog-container',
              data: {
                mainHeading: `Kindly note the serial number ${response.data.mem_key} `,
                subHeading: `Please write the serial number on diksha patra page.`,
                buttonValue: 'Finish',
              },
            });
            this.dialogRef.close(true);
          }
        },
        error: (error) => {
          this.toaster.error(error);
        },
      });
    }
  }
  restrictNumberInput(event: KeyboardEvent): void {
    const input = event.key;
    const pattern = /[0-9]/;

    if (
      this.allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }
    if (!pattern.test(input)) {
      event.preventDefault();
    }
  }
  restrictNameInput(event: KeyboardEvent): void {
    const input = event.key;

    const pattern = /^[a-zA-Z\s]+$/;
    if (
      this.allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }
    if (!pattern.test(input)) {
      event.preventDefault(); // Prevent input if it doesn't match the pattern
    }
  }

  restrictAddressInput(event: KeyboardEvent): void {
    const input = event.key;
    const limit = event.target as HTMLInputElement;

    const pattern = /^[a-zA-Z0-9@,-\s]+$/;
    if (
      this.allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }
    if (!pattern.test(input) || limit.value.length > 120) {
      event.preventDefault();
    }
  }
}
